The draft position profile for the given `id`.

This query accepts browser tokens that include the `query:enhanced-job-posting` scope.
